import FinancialPageContent from '../components/financial/FinancialPageContent';

const FinancialPage = () => {
  return <FinancialPageContent />;
};

export default FinancialPage;